import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/boost/arrow@2x.png")